import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { indexStore } from "../../../store/indexStore";
import Visibility from "../../../components/utils/Visibility";
import IsNotActive from "../../../components/IsNotActive/IsNotActive";
import NewProductScreen from "../../../components/ProductScrens/NewProductScreen";
import OldProductScreen from "../../../components/ProductScrens/OldProductScreen";
import { AddToRecentlyViewed } from "../../../components/utils/RecentlyViewed";
function Product() {

  const {
    fetchBrancheAction,
    product,
    fetchProductByAction,
branch
  } = indexStore();
  const params = useParams();


  useEffect(() => {
    // إذا كان كائن الفرع فارغًا، نجلب بيانات الفرع، وإلا لا نفعل شيئًا
    if (!branch || Object.keys(branch).length === 0) {
      fetchBrancheAction({ branch_id: params.branch_id });
    }

    fetchProductByAction({
      productId: params.product,
      branch_id: params.branch_id,
    });
  }, []);
  console.log(product, "product");

  useEffect(() => {
    if (Object.keys(product).length !== 0) {
      const menuId = params.menu !== undefined ? params.menu : "";
      AddToRecentlyViewed(
        { ...product, menu_id: menuId },
        Number(params.branch_id)
      );
    }
  }, [product]);
  const screen: number = 2;

  return (
    <IsNotActive>
      <div className="bg-background flex-grow">
        <Visibility visible={screen == 1}>
          <OldProductScreen />
        </Visibility>
        <Visibility visible={screen == 2}>
          <NewProductScreen />
        </Visibility>
      </div>
    </IsNotActive>
  );
}

export default Product;
